import { useState } from 'react';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext.jsx';
import axios from 'axios';

function LikeButton({ itemType, itemId, hasLikedInitial, likeCountInitial, userId }) {
    const { token } = useAuth();
    const { backendApiBaseUrl } = useConfig();
    const [hasLiked, setHasLiked] = useState(hasLikedInitial);
    const [likeCount, setLikeCount] = useState(likeCountInitial);

    const parseItemId = (itemKey) => {   
        if (typeof itemKey === 'string' && itemKey.includes('-')) {
            const [type, id] = itemKey.split('-');
            return { type, id: parseInt(id, 10) };
        } else {
            return { type: undefined, id: parseInt(itemKey, 10) };
        }
    };

    const toggleLike = async () => {
        if (!userId) return;
        const { type, id } = parseItemId(itemId);
        try {
            if (hasLiked) {
                await axios.delete(`${backendApiBaseUrl}/likes`, {
                    data: { itemType, userId, id, type },
                    headers: {
                        Authorization: `Bearer ${token.token}`,
                    },
                });
                setLikeCount(likeCount - 1);
            } else {
                await axios.post(`${backendApiBaseUrl}/likes`, 
                    {itemType,  userId, id, type },
                    {
                        headers: {
                            Authorization: `Bearer ${token.token}`,
                        },
                    }
                );
                setLikeCount(likeCount + 1);
            }
            setHasLiked(!hasLiked);
        } catch (err) {
            console.error("Failed to toggle like", err);
        }
    };

    return (
        <div onClick={toggleLike} style={{ cursor: 'pointer' }}>
            <i className={hasLiked ? "fa-solid fa-thumbs-up" : "fa-regular fa-thumbs-up"}></i>
            <span style={{ marginLeft: '5px' }}>{likeCount}</span>
        </div>
    );
}

export default LikeButton;
